import { Content, Flex, Heading, IllustratedMessage } from '@adobe/react-spectrum';
import Error from '@spectrum-icons/illustrations/Error';
import p from 'prop-types';
import React from 'react';

/**
 * Component used to display a generic error when the entire app crashed.
 * @returns JSX.Element
 */
const AppCrashComponent = (props) => (
  <Flex width="100%" height="100%" direction="column" justifyContent="center" alignItems="center" minHeight="70vh">
    <IllustratedMessage paddingY="size-2000">
      <Error aria-hidden role="presentation" />
      <Heading>Something went wrong and the {props.appName ? props.appName + ' ' : ''}app crashed...</Heading>
      <Content>We have been notified of the error. Try refreshing the page or try again in a few minutes.</Content>
    </IllustratedMessage>
  </Flex>
);

AppCrashComponent.propTypes = {
  /** Name of the application that crashed (eg.: Browse) */
  appName: p.string,
};

export default AppCrashComponent;
